import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import stringHelper from 'utils/stringHelper';

import Stack from '@mui/material/Stack';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';


import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';



import CircularProgress from '@mui/material/CircularProgress';

import { green } from '@mui/material/colors';


const styles = theme => ({
    cardActions: {
        justifyContent: 'right'
    },


    formControl: {
        margin: 0,
        width: '100%'
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    }

});




class QualificationCodeContactTelephoneManquantInnerForm extends React.Component {


    constructor(props) {
        super(props);

        // Initialisation du state
        this.state = this.getInitialState(props.open);
    }

    getInitialState = (open) => {
        const initialState = {
            open: open,
            contact: '',
            telephone: '',
            commentaire: ''
        };
        return initialState;
    }



    handleChange = (event) => {
        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };
        
        this.setState(newState);

    }


    handleClickAnswer = (event) => {
        const newState = {
            ...this.state,
            open: true
        };

        this.setState(newState);
    }

    handleClickCancel = (event) => {

        this.setState(this.getInitialState());

        if (this.props.onClickCancelFallback) {
            this.props.onClickCancelFallback();
        }
    }
    
    handleClickSave = (event) => {
        const { contact, telephone, commentaire } = this.state;

        this.props.onClickSave(contact, telephone, commentaire);
    }


    render() {
        const { classes, isAdding } = this.props;

        const { open, contact, telephone, commentaire } = this.state;

        let sauvegardable = !stringHelper.isNullOrWhitespace(contact) && !stringHelper.isNullOrWhitespace(telephone);



        return (

            <React.Fragment>

                <div hidden={open || isAdding}>
                    <Button onClick={this.handleClickAnswer} variant="outlined" >Répondre</Button>
                </div>


                <Card hidden={!open && !isAdding}>

                    <CardContent sx={{ minWidth: '500px' }}>

                        <Stack spacing={1}>

                            <TextField className={classes.formControl}
                                required
                                id="contact"
                                name="contact"
                                label="Contact"
                                placeholder="Contact"
                                margin="normal"
                                value={contact}
                                onChange={this.handleChange}
                            />

                            <TextField className={classes.formControl}
                                required
                                id="telephone"
                                name="telephone"
                                label="Téléphone"
                                placeholder="Téléphone"
                                multiline
                                margin="normal"
                                value={telephone}
                                onChange={this.handleChange}
                            />

                            <TextField className={classes.formControl}
                                id="commentaire"
                                name="commentaire"
                                label="Commentaire"
                                placeholder="Commentaire"
                                multiline
                                margin="normal"
                                value={commentaire}
                                onChange={this.handleChange}
                            />

                        </Stack>

                    </CardContent >




                    <CardActions classes={{ root: classes.cardActions }}>
                        <Button onClick={this.handleClickCancel} color="primary" >Annuler</Button>
                        <Button
                            onClick={this.handleClickSave}
                            variant="contained"
                            color="secondary"
                            disabled={!sauvegardable || isAdding}
                        >
                            {isAdding === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                            Enregistrer
                                </Button>
                    </CardActions>


                </Card>
            </React.Fragment>
        );
    }
}
QualificationCodeContactTelephoneManquantInnerForm.propTypes = {
    isAdding: PropTypes.bool.isRequired
};

export default withStyles(styles)(QualificationCodeContactTelephoneManquantInnerForm);